import { securePut } from './http-module';

const LIVE_ALLOWED_URI =
  '/api/bff-transaction/private/transactions/live/allowed';
let hasPermission = undefined;

const liveTransactionPermission = {};

liveTransactionPermission.hasPermission = () => {
  if (hasPermission != undefined) return Promise.resolve(hasPermission);
  return securePut(LIVE_ALLOWED_URI)
    .then(v => {
      return (hasPermission = true);
    })
    .catch(e => {
      return (hasPermission = false);
    });
};

export default liveTransactionPermission; 
